exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ModalLoading_div_1ima8 {\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n    position: relative;\n    /*background: white;*/\n    top: 50%;\n    left: 50%;\n    padding: 2% 5%;\n    border-radius: 10px;\n    box-sizing: border-box;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    text-align: center;\n}\n\n.ModalLoading_faSpinner_B5SgF {\n    color: white;\n}\n\n.ModalLoading_loading_3v82y {\n    color: white;\n    margin-top: 10%;\n    font-weight: bold;\n}\n", ""]);

// exports
exports.locals = {
	"div": "ModalLoading_div_1ima8",
	"faSpinner": "ModalLoading_faSpinner_B5SgF",
	"loading": "ModalLoading_loading_3v82y"
};